import { render, staticRenderFns } from "./Vintage.vue?vue&type=template&id=225e393e&scoped=true&"
import script from "./Vintage.vue?vue&type=script&lang=js&"
export * from "./Vintage.vue?vue&type=script&lang=js&"
import style0 from "./Vintage.vue?vue&type=style&index=0&id=225e393e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e393e",
  null
  
)

export default component.exports